__turbopack_context__.v({
  "camera": "FlywaysMap-module__LPSjdW__camera",
  "gestureHost": "FlywaysMap-module__LPSjdW__gestureHost",
  "gestureLayer": "FlywaysMap-module__LPSjdW__gestureLayer",
  "plate": "FlywaysMap-module__LPSjdW__plate",
  "preview": "FlywaysMap-module__LPSjdW__preview",
  "status": "FlywaysMap-module__LPSjdW__status",
  "svgHost": "FlywaysMap-module__LPSjdW__svgHost",
  "twoFingerTip": "FlywaysMap-module__LPSjdW__twoFingerTip",
  "viewport": "FlywaysMap-module__LPSjdW__viewport",
  "viewportCompact": "FlywaysMap-module__LPSjdW__viewportCompact",
});
